import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const root = document.getElementById('root')
console.log('Root element:', root)

// Add global error handler
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

// Add unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

try {
  createRoot(root!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
} catch (error) {
  console.error('Rendering error:', error)
  // Display a fallback UI
  document.body.innerHTML = `
    <div style="padding: 20px;">
      <h1>Something went wrong</h1>
      <pre style="color: red;">${error}</pre>
    </div>
  `
}
